import { Box, MenuItem, Typography } from '@mui/material'
import { NNROrderHandlingBoxFooter } from '@planning/pages/GateClerk/Components/NNROrderHandlingBoxFooter'
import { OperationTypeChip } from '@planning/pages/GateClerk/Components/OperationTypeChip'
import { CustomAlert } from '@planning/pages/TallymanV2/Components/CustomAlert'
import { NonNumericOrderWithPickUpAmount } from '@planning/stores/truckAppointment/TruckAppointmentDetailsViewStore'
import { isAfterValidityTimestamp } from '@planning/utils/release-validity-utils'
import { useTranslate } from '@tolgee/react'
import { CloseButton, ThreeDotMenu } from '@tom-ui/ui'
import { FC, useState } from 'react'

interface Props {
  nnrOrder: NonNumericOrderWithPickUpAmount
  arrivalDate?: string | null
  showNoContainerAlert?: boolean
  showThreeDotMenu?: boolean
  isForAppointment?: boolean
  onEditPickUpAmount?: (nnrOrder: NonNumericOrderWithPickUpAmount) => void
  onRemove?: (nnrOrder: NonNumericOrderWithPickUpAmount) => void
}

export const NNROrderListItem: FC<Props> = ({
  nnrOrder,
  arrivalDate,
  showThreeDotMenu,
  showNoContainerAlert,
  isForAppointment,
  onEditPickUpAmount,
  onRemove,
}) => {
  const { t } = useTranslate()
  const [isEditingPickUpAmount, setEditingPickUpAmount] = useState<boolean>(!nnrOrder.pickUpAmount)
  const showValidityDateWarning =
    // Temporary workaround: compare full timestamp, not calendar day.
    isAfterValidityTimestamp(arrivalDate, nnrOrder.validityDate)

  return (
    <Box display='flex' flexDirection='column'>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: '1rem',
        }}
      >
        <Box>
          <Typography variant='subtitle1'>{nnrOrder.referenceNumber}</Typography>
          <Typography variant='body2'>
            {nnrOrder.pickUpAmount}x {t('nonNumericContainers', 'non-numeric containers')}
          </Typography>
          <OperationTypeChip direction={'Outbound'} />
          {showNoContainerAlert && (
            <CustomAlert
              message={t(
                'noContainerHasBeenAssignedContactControlRoom',
                'No container has been assigned, contact control room',
              )}
              severity='warning'
              margin='0.5rem 0 0 0'
            />
          )}
          {showValidityDateWarning && (
            <CustomAlert
              message={t(
                'truckShouldArriveBeforeValidityDate',
                'Truck should arrive before the validity date.',
              )}
              severity='warning'
              margin='0.5rem 0 0 0'
            />
          )}
        </Box>

        {!!onRemove && !showThreeDotMenu && (
          <CloseButton onClose={() => onRemove(nnrOrder)} tooltip={t('remove', 'Remove')} />
        )}
        {showThreeDotMenu && (
          <ThreeDotMenu>
            {nnrOrder.pickUpAmount && onEditPickUpAmount ? (
              <MenuItem onClick={() => setEditingPickUpAmount(true)}>
                {t('editPickUpAmount', 'Edit Pick Up Amount')}
              </MenuItem>
            ) : (
              <div></div>
            )}
            {onRemove ? (
              <MenuItem onClick={() => onRemove(nnrOrder)}>{t('remove', 'Remove')}</MenuItem>
            ) : (
              <></>
            )}
          </ThreeDotMenu>
        )}
      </Box>
      <NNROrderHandlingBoxFooter
        order={nnrOrder}
        isForAppointment={isForAppointment}
        isEditing={isEditingPickUpAmount}
        onClickAdd={nnr => {
          onEditPickUpAmount?.(nnr)
          setEditingPickUpAmount(false)
        }}
      />
    </Box>
  )
}
